import { useRef } from '@wordpress/element';
import isShallowEqual from '@wordpress/is-shallow-equal';

export const useShallowEqual = (value) => {
    const ref = useRef(value);
    if (!isShallowEqual(value, ref.current)) {
        ref.current = value;
    }
    return ref.current;
};
